// Copyright Open Trade Technology Ltd. 2023. All rights reserved.

export interface TokenMetadata {
  address: string
  symbol: string
  name: string
  decimals: number
  logoUrl?: string
  isCore?: boolean
}

export interface SwapTokenConfig {
  TOKEN_A: TokenMetadata
  TOKEN_B: TokenMetadata
  dexPools: {
    TOKEN_A_TOKEN_B_POOL: string
  }
  availableTokens: TokenMetadata[]
}

export const SWAP_TOKEN_CONFIG: Record<string, Record<number, SwapTokenConfig>> = {
  qasierra: {
    43114: {
      TOKEN_A: {
        address: '0xb97ef9ef8734c71904d8002f8b6bc66dd9c48a6e',
        symbol: 'USDC',
        name: 'USD Coin',
        decimals: 6,
        isCore: true,
      },
      TOKEN_B: {
        address: '0x4f2ac6f077b1678a1e22db76194bdb8347d10118',
        symbol: 'LytQa',
        name: 'Lyt QA Token',
        decimals: 6,
        isCore: true,
      },
      dexPools: {
        TOKEN_A_TOKEN_B_POOL: '0x0000000000000000000000000000000000000000',
      },
      availableTokens: [
        {
          address: '0xb97ef9ef8734c71904d8002f8b6bc66dd9c48a6e',
          symbol: 'USDC',
          name: 'USD Coin',
          decimals: 6,
          isCore: true,
        },
        {
          address: '0x4f2ac6f077b1678a1e22db76194bdb8347d10118',
          symbol: 'LytQa',
          name: 'Lyt QA Token',
          decimals: 6,
          isCore: true,
        },
      ],
    },
  },
  qasierrafb: {
    43113: {
      TOKEN_A: {
        address: '0xAb231A5744C8E6c45481754928cCfFFFD4aa0732',
        symbol: 'USDT',
        name: 'Testnet USDT',
        decimals: 6,
        isCore: true,
      },
      TOKEN_B: {
        address: '0x740B3209a72B70D8132198cF593A79735bE11678',
        symbol: 'SYT',
        name: 'Sierra T LFJ',
        decimals: 6,
        isCore: true,
      },
      dexPools: {
        TOKEN_A_TOKEN_B_POOL: '0xE44Cd88ad162CC97D40a875436772b1fc43dA447',
      },
      availableTokens: [
        {
          address: '0xAb231A5744C8E6c45481754928cCfFFFD4aa0732',
          symbol: 'USDT',
          name: 'Testnet USDT',
          decimals: 6,
          isCore: true,
        },
        {
          address: '0x740B3209a72B70D8132198cF593A79735bE11678',
          symbol: 'SYT',
          name: 'Sierra T LFJ',
          decimals: 6,
          isCore: true,
        },
      ],
    },
  },
  prodsierra: {
    43114: {
      TOKEN_A: {
        address: '0xb97ef9ef8734c71904d8002f8b6bc66dd9c48a6e',
        symbol: 'USDC',
        name: 'USD Coin',
        decimals: 6,
        isCore: true,
      },
      TOKEN_B: {
        address: '0x6E6080e15f8C0010d333D8CAeEaD29292ADb78f7',
        symbol: 'SIERRA',
        name: 'Sierra',
        decimals: 6,
        isCore: true,
      },
      dexPools: {
        TOKEN_A_TOKEN_B_POOL: '0x0000000000000000000000000000000000000000',
      },
      availableTokens: [
        {
          address: '0xb97ef9ef8734c71904d8002f8b6bc66dd9c48a6e',
          symbol: 'USDC',
          name: 'USD Coin',
          decimals: 6,
          isCore: true,
        },
        {
          address: '0x6E6080e15f8C0010d333D8CAeEaD29292ADb78f7',
          symbol: 'SIERRA',
          name: 'Sierra',
          decimals: 6,
          isCore: true,
        },
      ],
    },
  },
  prodsierracanary: {
    43114: {
      TOKEN_A: {
        address: '0xb97ef9ef8734c71904d8002f8b6bc66dd9c48a6e',
        symbol: 'USDC',
        name: 'USD Coin',
        decimals: 6,
        isCore: true,
      },
      TOKEN_B: {
        address: '0x6E6080e15f8C0010d333D8CAeEaD29292ADb78f7',
        symbol: 'SIERRA',
        name: 'Sierra',
        decimals: 6,
        isCore: true,
      },
      dexPools: {
        TOKEN_A_TOKEN_B_POOL: '0x0000000000000000000000000000000000000000',
      },
      availableTokens: [
        {
          address: '0xb97ef9ef8734c71904d8002f8b6bc66dd9c48a6e',
          symbol: 'USDC',
          name: 'USD Coin',
          decimals: 6,
          isCore: true,
        },
        {
          address: '0x6E6080e15f8C0010d333D8CAeEaD29292ADb78f7',
          symbol: 'SIERRA',
          name: 'Sierra',
          decimals: 6,
          isCore: true,
        },
      ],
    },
  },
  localsierra: {
    43114: {
      TOKEN_A: {
        address: '0xb97ef9ef8734c71904d8002f8b6bc66dd9c48a6e',
        symbol: 'USDC',
        name: 'USD Coin',
        decimals: 6,
        isCore: true,
      },
      TOKEN_B: {
        address: '0x4f2ac6f077b1678a1e22db76194bdb8347d10118',
        symbol: 'LytQa',
        name: 'Lyt QA Token',
        decimals: 6,
        isCore: true,
      },
      dexPools: {
        TOKEN_A_TOKEN_B_POOL: '0x0000000000000000000000000000000000000000',
      },
      availableTokens: [
        {
          address: '0xb97ef9ef8734c71904d8002f8b6bc66dd9c48a6e',
          symbol: 'USDC',
          name: 'USD Coin',
          decimals: 6,
          isCore: true,
        },
        {
          address: '0x4f2ac6f077b1678a1e22db76194bdb8347d10118',
          symbol: 'LytQa',
          name: 'Lyt QA Token',
          decimals: 6,
          isCore: true,
        },
      ],
    },
  },
  devsierra: {
    43113: {
      TOKEN_A: {
        address: '0xAb231A5744C8E6c45481754928cCfFFFD4aa0732',
        symbol: 'USDT',
        name: 'Testnet USDT',
        decimals: 6,
        isCore: true,
      },
      TOKEN_B: {
        address: '0x740B3209a72B70D8132198cF593A79735bE11678',
        symbol: 'SYT',
        name: 'Sierra T LFJ',
        decimals: 6,
        isCore: true,
      },
      dexPools: {
        TOKEN_A_TOKEN_B_POOL: '0xE44Cd88ad162CC97D40a875436772b1fc43dA447',
      },
      availableTokens: [
        {
          address: '0xAb231A5744C8E6c45481754928cCfFFFD4aa0732',
          symbol: 'USDT',
          name: 'Testnet USDT',
          decimals: 6,
          isCore: true,
        },
        {
          address: '0x740B3209a72B70D8132198cF593A79735bE11678',
          symbol: 'SYT',
          name: 'Sierra T LFJ',
          decimals: 6,
          isCore: true,
        },
      ],
    },
  },
}

export function getSwapTokenConfig(stageName: string, chainId: number): SwapTokenConfig {
  const stageConfig = SWAP_TOKEN_CONFIG[stageName.toLowerCase()]
  if (!stageConfig) {
    console.error(`Swap config NOT FOUND for stage: ${stageName}`)
    throw new Error(`Unsupported swap configuration for stage: ${stageName}`)
  }

  const config = stageConfig[chainId]
  if (!config) {
    console.error(`Swap config NOT FOUND for stage: ${stageName}, chainId: ${chainId}`)
    throw new Error(`Unsupported swap configuration for stage: ${stageName}, chainId: ${chainId}`)
  }

  console.warn(`Using swap config: ${stageName}-${chainId} (${config.TOKEN_B.symbol})`)
  return config
}

export function getTokenMetadata(stageName: string, chainId: number, tokenAddress: string): TokenMetadata | undefined {
  const config = getSwapTokenConfig(stageName, chainId)
  return config.availableTokens.find((token) => token.address.toLowerCase() === tokenAddress.toLowerCase())
}

export function getAvailableTokens(stageName: string, chainId: number): TokenMetadata[] {
  const config = getSwapTokenConfig(stageName, chainId)
  return config.availableTokens
}

export function getTokenPair(stageName: string, chainId: number): { tokenA: TokenMetadata; tokenB: TokenMetadata } {
  const config = getSwapTokenConfig(stageName, chainId)
  return {
    tokenA: config.TOKEN_A,
    tokenB: config.TOKEN_B,
  }
}
